import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "linkedin",
  "use": "linkedin-usage",
  "viewBox": "0 0 512 511",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 511\" id=\"linkedin\"><path class=\"st0\" d=\"M8.4 169.5h106.2v342H8.4zM61.6 122.8C27.5 122.8 0 95.2 0 61.2S27.5-.5 61.6-.5c33.9 0 61.5 27.6 61.5 61.6s-27.6 61.7-61.5 61.7zM512 511.5H405.9V345.2c0-39.7-.7-90.7-55.1-90.7-55.2 0-63.6 43.2-63.6 87.8v169.2h-106v-342h101.7v46.8h1.5c14.2-26.9 48.7-55.2 100.4-55.2C492.2 161.1 512 231.9 512 324v187.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./sv_cms/static/assets/images/icons/linkedin.svg
// module id = 283
// module chunks = 6